// extracted by mini-css-extract-plugin
var _1 = "TableCellEditButton-moduleedit__YZdJ_";
export { _1 as "edit" }
